// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9159f59b","457":"e8d94d24","640":"0b1bd271","667":"362b2229","720":"17b26c7e","851":"5eeb28c7","908":"1038f5a7"}[chunkId] + ".chunk.js";
};